// Ruta de la api http://api-siscor.guarico.gob.ve/api;
// Ruta de la api http://localhost:8000/api;
export const URL = 'http://api-siscor.guarico.gob.ve/api';
// export const URL = "http://localhost:8000/api";
